import moment from "moment";
import { Role } from "../../../domain/model/client";
import { entity } from "../rpc/api";
import ClientList = entity.ClientList;

class ClientConvertResponse {
  public static from(from: entity.Client): ClientConvertResponse {
    // Backend => FrontEnd における型変換
    const createdAtDate: Date = ClientConvertResponse.convertToDate(
      from.createdAt
    );

    return new ClientConvertResponse(
      from.id,
      from.companyID,
      from.name,
      from.nameKana,
      from.gsIconURL,
      from.signedIconURL,
      from.phoneNumber,
      from.department,
      from.position,
      from.email,
      createdAtDate,
      from.role
    );
  }

  // Backend => FrontEnd における型変換　日付があればDate変換　なければ今日のDateを入れる
  private static convertToDate = (dateString: string): Date => {
    return dateString
      ? moment(dateString, "YYYY-MM-DD HH:II:SS").toDate()
      : moment().toDate();
  };

  constructor(
    // アカウントID
    public readonly id: string,
    // 企業ID
    public readonly companyID: string,
    // 名前
    public readonly name: string,
    // 名前（ふりがな）
    public readonly nameKana: string,
    // プロフィール画像
    public readonly gsIconURL: string,
    public readonly signedIconURL: string,
    // 電話番号
    public readonly phoneNumber: string,
    // 部署
    public readonly department: string,
    // 役職
    public readonly position: string,
    // メールアドレス
    public readonly email: string,
    // （タイムスタンプ）
    public readonly createdAt: Date,

    public readonly role: Role
  ) {}
}

class ClientConvertResponseList {
  public static from(from: ClientList): ClientConvertResponseList {
    const items: ClientConvertResponse[] = [];

    from.items.map((item, index) => {
      return items.push(ClientConvertResponse.from(item as entity.Client));
    });

    return new ClientConvertResponseList(items);
  }

  constructor(public readonly items: ClientConvertResponse[]) {}
}

export { ClientConvertResponse, ClientConvertResponseList };



// WEBPACK FOOTER //
// ./src/infra/api/service/client_api_convert.ts